<template lang="pug">
  div.contract-tko-transports.body.body-table
    div.table-choose-panel
      div.toolbar-table
        div.toolbar.toolbar_no-padding.toolbar_margin-bottom
          div.toolbar__line
            div
            e-button-edit(
              @click.stop.prevent="addNewRowToTable"
              )

      div
        e-table-inner(
        :visibleColumns="visibleColumns"
        :itemsEndpoint="endpointListForInnerTable"
        @deleteItem="deleteItem"
        ref="innerTable"
        )

      e-modal(v-if="showModal"
      @close="showModal = false"
      @confirm="saveList()"
      title="Транспортировщики по Договору"
      )
        slot
          e-table-checked-list(
          @checkedChange="listUpdate($event)"
          :endpoint="endpointList"
          :earlyCheckedItems="earlyChecked"
          :showPaginate="true"
          :transformUserFriendlyEr="tableCheckedListTransformUserFriendlyEr"
          )

        template(slot="footer")
          div.search-result
            span Выбрано {{checkedLen}} объектов
          div
            button(
            type="button"
            @click="closeModal()"
            ).reset-btn.button.button_no-border.button_color.modal__button Отмена
            button(
            type="button"
            @click="saveList()"
            ).actions-filter-panel__button.standart.button.account__button.reset-btn.button_usual.semibold Сохранить


</template>

<script>
import { tko } from '@/api/api-endpoints'
import userFriendlyEr from '@/utils/userFriendlyEr'

export default {
  name: 'contract-transports',
  props: {
    fields: Object,
  },
  data() {
    return {
      operationType: null,
      showModal: false,
      checkedLen: 0,
      checked: [],
    }
  },
  computed: {
    visibleColumns() {
      return {
        name: {
          label: 'Транспортировщик',
        },
        legal_address: {
          label: 'Юридический адрес',
        },
        fact_address: {
          label: 'Местоположение',
        },
      }
    },
    selectListOptions() {
      return [
        {
          id: 'contract-transport',
          name: 'Транспортировщики ТКО',
        },
      ]
    },
    earlyChecked() {
      return { default: this.fields[this.idsFieldName] }
    },
    idsFieldName() {
      return 'tko_operator_transport_id'
    },
  },
  methods: {
    tableCheckedListTransformUserFriendlyEr(e, endpoint) {
      if (!this.fields.tko_operator_id) {
        return 'Укажите исполнителя чтобы получить возможность выбирать транспортировщика'
      }
      return userFriendlyEr.recognize(e, endpoint)
    },
    updateDataInInnerTable() {
      this.$refs.innerTable.fetchData()
    },
    deleteItem(item) {
      let tmp = []
      this.fields[this.idsFieldName].forEach((vId) => {
        if (item.id !== vId) {
          tmp.push(vId)
        }
      })
      this.fields[this.idsFieldName] = tmp
      this.$emit('delete')
      this.updateDataInInnerTable()
    },
    endpointListForInnerTable(ctx, query = { 'per-page': 10 }) {
      let route = { query }
      if (ctx.q) {
        route.query.q = ctx.q
      }
      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      if (ctx.currentSort) {
        route.query.sort = ctx.currentSort
      }
      if (
        this.fields &&
        this.fields[this.idsFieldName] &&
        this.fields[this.idsFieldName].length
      ) {
        route.query.id = this.fields[this.idsFieldName]
      } else {
        route.query.id = [-1]
      }
      return {
        url: tko.operators(route),
      }
    },
    endpointList(ctx, query = { 'per-page': 50 }) {
      let route = { query }
      if (ctx.q) {
        route.query.q = ctx.q
      }
      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      if (ctx.currentSort) {
        route.query.sort = ctx.currentSort
      }

      route.query.tko_operator_service_id = this.fields.tko_operator_id

      return {
        url: route.query.tko_operator_service_id ? tko.operators(route) : null,
        fields: {
          name: {
            label: 'Транспортировщик',
          },
          legal_address: {
            label: 'Юридический адрес',
          },
          fact_address: {
            label: 'Местоположение',
          },
        },
      }
    },
    listUpdate($event) {
      let { checked, checkedLen } = $event
      this.checkedLen = checkedLen
      this.checked = checked.default
    },
    saveList() {
      this.$set(
        this.fields,
        this.idsFieldName,
        JSON.parse(JSON.stringify(this.checked))
      )
      this.closeModal()
      this.$emit('saved')
      this.updateDataInInnerTable()
    },
    closeModal() {
      this.showModal = false
      this.checkedLen = 0
    },
    openModal() {
      this.showModal = true
    },
    addNewRowToTable() {
      this.openModal()
    },
  },
}
</script>
